/**
 * API origin for axios/fetch.
 *
 * Priority:
 * 1. REACT_APP_API_URL (e.g. http://192.168.1.42:3001)
 * 2. Same host as the page on port 3001 (LAN access without env)
 * 3. http://localhost:3001
 */
export function resolveApiBaseUrl() {
  const fromEnv = (process.env.REACT_APP_API_URL || "").trim().replace(/\/$/, "");
  if (fromEnv) return fromEnv;

  if (typeof window !== "undefined" && window.location?.hostname) {
    const { protocol, hostname } = window.location;
    if (hostname && hostname !== "localhost" && hostname !== "127.0.0.1") {
      return `${protocol}//${hostname}:3001`;
    }
  }

  return "http://localhost:3001";
}

export const API_BASE_URL = resolveApiBaseUrl();

/** Build an absolute API URL from a path (`/auth/login` or `auth/login`). */
export function apiUrl(path = "") {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${API_BASE_URL}${normalized}`;
}
